module.exports = __webpack_public_path__ + "img/facebook.b844f9d0.svg";